"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.authErrorSelector = authErrorSelector;
exports.hasAuthErrorSelector = hasAuthErrorSelector;
exports.isSubmittingSelector = isSubmittingSelector;
exports.phoneSelector = phoneSelector;
exports.resendTimeoutSelector = resendTimeoutSelector;
exports.sendValidationCodeStatusSelector = sendValidationCodeStatusSelector;
var _requestStatus = require("../../../../types/requestStatus");
var _authentication = require("../../../../types/authentication");
function phoneSelector(state) {
  return state.authentication.twoFactor.phoneState.phone;
}
function sendValidationCodeStatusSelector(state) {
  return state.authentication.twoFactor.phoneState.status;
}
function isSubmittingSelector(state) {
  return state.authentication.authenticate.status === _authentication.EAuthenticateStatus.Loading || state.authentication.twoFactor.phoneState.status === _requestStatus.ERequestStatus.Loading || state.authentication.authenticate.status === _authentication.EAuthenticateStatus.Succeed;
}
function resendTimeoutSelector(state) {
  return state.authentication.twoFactor.phoneState.secondsToRetry;
}
function hasAuthErrorSelector(state) {
  const {
    status: authStatus,
    error: authError
  } = state.authentication.authenticate;
  const {
    status: smsStatus,
    error: smsError
  } = state.authentication.twoFactor.phoneState;
  return authStatus === _authentication.EAuthenticateStatus.Failed && authError !== undefined || smsStatus === _requestStatus.ERequestStatus.Failed && smsError !== undefined;
}
function authErrorSelector(state) {
  return hasAuthErrorSelector(state) ? state.authentication.authenticate.error || state.authentication.twoFactor.phoneState.error : undefined;
}